export default "__VITE_ASSET__46ca6c92__"